"use client";

import dynamic from "next/dynamic";

const SearchSoundEffectsInput = dynamic(() =>
  import("./SearchSoundEffectsInput").then(mod => mod.SearchSoundEffectsInput),
);

export default SearchSoundEffectsInput;
